const elementId = 'carList';

let getElement = function (resolve, page = 1) {
    //resolve - калбек промисса
    $.ajax({
        type: 'GET',
        url: '/garage/api/v1/getCars/',
        dataType: 'json',
        data: {
            page: page,
        },
        success: function (data) {
            updateCarStortage(data);
            resolve(data);
        },
    });
};

let updateCarStortage = function (data) {
    localStorage.setItem(elementId, JSON.stringify(data));
};

async function getCarList(page = 1) {
    if (window.localStorage != undefined && process.env.MODE !== 'dev') {
        // localStorage доступен
        if (localStorage.getItem(elementId) && page !== 1) {
            let data = JSON.parse(localStorage.getItem(elementId));
            return data;
        } else {
            let data = new Promise((resolve) => {
                getElement(resolve, page);
            });
            return await data;
        }
    } else {
        let data = new Promise((resolve) => {
            getElement(resolve, page);
        });
        return await data;
    }
}

async function updateCarList() {
    let data = new Promise(function (resolve) {
        getElement(resolve);
    });
    return await data;
}

export { getCarList, updateCarList, updateCarStortage };
